import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/shadcn-components/ui/card";

interface TradeCloseByContentProps {
  // Props będą dodane w przyszłości
}

export default function TradeCloseByContent({}: TradeCloseByContentProps) {
  return (
    <div className="space-y-4">
      {/* Placeholder - zawartość będzie dodana później */}
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Close By</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center text-muted-foreground py-8">
            <p className="text-sm">Close By functionality will be implemented here</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}